import React, { useState } from 'react';
import './ToolSearch.css';

const ToolSearch = ({ onSearch }) => {
  const [searchText, setSearchText] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    onSearch(value); // pass search value up to parent
  };

  return (
    <div className="tool-search">
      <input
        type="text"
        placeholder="Search tools..."
        value={searchText}
        onChange={handleChange}
      />
    </div>
  );
};

export default ToolSearch;
